<template>
  <b-modal
    @hide="refreshPage"
    id="ownerUpdateConfirmModal"
    class="popover-modal"
    hide-header
    hide-footer
    no-close-on-esc
    ref="changeRoleByDiffAdminModal"
  >
    <div class="content-cont">
      <p class="header-title text-center">
        {{
          eventData && eventData.type && eventData.type == "user_type"
            ? "User Type"
            : "Site"
        }}
        Created
      </p>
      <div class="hint-modal">
        A new
        {{
          eventData && eventData.type && eventData.type == "user_type"
            ? "user type"
            : "site "
        }}
        <strong>“{{ eventData && eventData.name }}”</strong> has been created by
        admin
        <strong style="white-space: pre"
          >({{ eventData && eventData.created_by }}).</strong
        >
      </div>
      <!-- action btns  -->
      <hr class="h-line" />
      <div class="action-btns">
        <button
          @click="refreshPage"
          class="dismiss-action-btn btn btn-primary"
          size="md"
        >
          Okay
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: { eventData: {} },
  name: "ownerUpdateConfirmModal",
  methods: {
    refreshPage() {
      if (this.$route.name == "dashboard") window.location.reload();
      else window.location.href = "/";
    },
  },
};
</script>

<style lang="scss">
div#ownerUpdateConfirmModal {
  // background: #F3F3F3;
  padding-inline-end: 0px !important;
  border-radius: 26px;

  div#ownerUpdateConfirmModal___BV_modal_content_ {
    border-radius: 26px;
    width: 502.7px !important;
    top: 50px;
    // inset-inline-start: 30px;
  }
  .modal-content .modal-body {
    padding: 0px !important;
    // border-radius: 26px;
    p.header-title {
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      margin: 40px 0;
      color: #000000;
    }
    .hint-modal {
      width: 420px;
      font-weight: 400;
      font-size: 16px;
      line-height: 23.6px;
      margin: 0 auto 40px auto;
      text-align: center;
      color: #4a4a4a;
    }
    .h-line {
      opacity: 0.15;
      background: #707070;
      width: 420px;
      margin: 0px auto 24px auto;
    }
    .action-btns {
      margin-bottom: 20px;
      .dismiss-action-btn {
        background: #103f5e;
        border-radius: 16.6275px;
        width: 111px;
        height: 33px;
        color: #ffffff;

        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
      }
    }
    .bold-text {
      display: inline;
      font-weight: 700;
    }
  }
}
</style>
